import React from 'react';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import Select from '../../../../../components/input/Select/Select';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { STORE_STATUS_TEXT, STORE_STATUS_SELECT_LIST } from '../../../../../constants/service/app/brandConstants';
import { addAllItemToSelectList } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import TableColumnImg from '../../../../../components/table/TableColumnImg';

/**
 *  좋아요한 상품 리스트 컬럼
 */
const columns = (data) => {
  const { filterOption, onFilter } = data;

  return [
    {
      accessor: 'url',
      Header: '대표 이미지',
      width: 120,
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'storeId',
      Header: '브랜드 ID',
      filterable: true,
      width: 100,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: () => <TableFilterInput option={filterOption.storeId} onFilter={(storeId) => onFilter({ storeId })} />,
    },
    {
      accessor: 'storeName',
      Header: '브랜드명',
      filterable: true,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.storeId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.storeName} onFilter={(storeName) => onFilter({ storeName })} />
      ),
    },
    {
      accessor: 'storeStatus',
      Header: '브랜드 상태',
      filterable: true,
      width: 120,
      Cell: (row) => STORE_STATUS_TEXT[row.value] || '_',
      Filter: () => (
        <Select
          list={addAllItemToSelectList(STORE_STATUS_SELECT_LIST)}
          onChange={(storeStatus) => onFilter({ storeStatus })}
          defaultValue={filterOption.storeStatus}
          value={filterOption.storeStatus}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'createDate',
      Header: '브랜드 좋아요 일시',
      filterable: true,
      sortable: true,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_KOREAN_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.createDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(createDate) => onFilter({ createDate })}
        />
      ),
    },
  ];
};

export default columns;
